import React from "react";
import { FormComponent } from "../../../components/form/DynamicForm";
import { Form, Validators } from "../../../components/form/DynamicFormTs";
import * as XLSX from "xlsx";
import Http from "../../../Http";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import EnviarFacturaEmail from '../Facturar/EnviarFacturaEmail'

export default class FacturarUline extends FormComponent {
  componentDidMount() {
    this.FormConfig(
      { defaultUrl: "", saveUrl: "", backUrl: "" },
      new Form(
        [
          Form.Field("file", "guias_file", "guias", "", [Validators.required], 12),
          Form.Field("checkbox", "flete_logistico", "Reemplazar Flete x Servicio Logistico", false, [], 6),
        ],
        ["Guardar"],
        "Facturacion ULINE"
      ),
      this.formData
    );
  }

  onSubmit = () => {
    let { FormData, guias } = this.state;
    this.setState({ loading: true });
    let reader = new FileReader();
    const file = FormData.Fields.find((field) => field.Name === "guias_file")
      .Value;
    const flete_logistico = FormData.Fields.find((field) => field.Name === "flete_logistico").Value;
    reader.readAsArrayBuffer(file[0]);
    reader.onloadend = async (e) => {
      const data = new Uint8Array(e.target.result);
      var workbook = XLSX.read(data, { type: "array" });
      for (const sheetName of workbook.SheetNames) {
        if (sheetName === "Data") {
          const XL_row_object = XLSX.utils.sheet_to_json(
            workbook.Sheets[sheetName]
          );
          guias = XL_row_object.map((row) => ({
            folio: row["ProNum"] || row[" ProNum "] || row[" ProNum"],
            precio: row[" UlineRate "] || row["UlineRate"] || row[" UlineRate"],
            cpac: row[" CPAC "] || row["CPAC"] || row["cpac"],
          }));
        }
      }
      const Resp = await Http.post("facturacion-especial/uline/facturar", { folios: guias,  flete_logistico });
      if (Resp.error) {
        this.setState({ loading: false, sbOpen: true, sbMsg: Resp.errMsg });
      } else if (Resp.data) {
        this.setState({
          factura: Resp.data,
          viewPdf: true,
          loading: false,
        });
      }
    };
  };

  handleDownloadFiles = async () => {
    await this.handledownloadPdf();
    await this.handledownloadFile("xml-timbrado");
  };

  handledownloadFile = async (type) => {
    let id_guia = null;
    for (const guia of this.state.tableData.rows) {
      if (guia.recibida) {
        id_guia = guia.id;
      }
    }
    const Resp = await Http.post(
      "facturacion/file",
      { id_guia, type },
      true,
      "arraybuffer"
    );
    if (Resp) {
      const blob = new Blob([Resp], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `${id_guia}.xml`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      // this.props.history.goBack();
    }
  };

  handledownloadPdf = () => {
    const { pdfURL } = this.state;
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = pdfURL;
    a.download = `factura.pdf`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(pdfURL);
    // this.props.history.goBack();
  };

  viewPdfClose = () => {
    this.setState({ viewPdf: false });
  }

  render() {
    const { viewPdf, factura } = this.state;

    return (
      <div>
        <this.FormRender />
        <Dialog
          onClose={this.viewPdfClose}
          open={viewPdf || false}
          fullWidth={true}
          maxWidth={"xl"}
        >
          <DialogTitle onClose={this.viewPdfClose}>Vista Previa</DialogTitle>
          <DialogContent dividers>
            <EnviarFacturaEmail factura={factura} credito />
          </DialogContent>
          <DialogActions>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
